import React from 'react'
import { useToggle } from 'react-use'
import { Link } from 'gatsby'
import { useApp } from './../../hooks/use-app-context'

function Header() {
  const [open, toggle] = useToggle(false)
  const [app, state, send] = useApp()

  return (
    <nav className="bg-white shadow-sm">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex items-center flex-shrink-0">
              <svg
                viewBox="0 0 1172 1172"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                className="w-auto h-8 text-red-500"
              >
                <g
                  id="Occasion-Logo-Black"
                  fill="currentColor"
                  fillRule="nonzero"
                >
                  <g
                    id="Group"
                    transform="translate(586.000000, 586.100000) scale(-1, 1) rotate(-180.000000) translate(-586.000000, -586.100000) translate(-0.000000, 0.100000)"
                  >
                    <path
                      d="M555.7,1170.5 C515.4,1164.5 478.1,1147.3 447.5,1120.8 C441.5,1115.6 349.8,1024.5 243.9,918.4 C38.1,712.4 43.9,718.4 29.2,693.8 C-2,641.4 -8.5,575.5 11.7,516.6 C19.4,494.3 33.8,468.9 49.2,450.6 C59.2,438.7 446.6,51.9 455,45.4 C472.2,32.1 496.3,18.8 515.4,12.2 C577.4,-9.4 647.2,-1.2 701.2,34 C706.9,37.7 715.1,43.6 719.5,47.1 C729.6,55 1116.5,441.8 1124.9,452.3 C1149.9,483.5 1165.4,519.4 1170.5,558 C1172.2,570.5 1172.4,600.1 1171,612.1 C1167.5,639.7 1158.5,666.9 1144.8,691.2 C1130.9,715.9 1138.6,707.8 923.1,923.2 C707.6,1138.8 715.9,1130.9 690.9,1145 C671.3,1156.2 647.5,1164.9 624.7,1169.2 C609.9,1172 570.7,1172.8 555.7,1170.5 Z M616,927.1 C712.9,918.3 801.4,869 859.7,791.4 C894.8,744.6 917.5,689 925.5,629.6 C927.8,613 928.6,576.7 927.1,558.9 C921.6,495.2 899.6,436 862.5,385.2 C805.6,307.3 721,258.1 624,246.5 C606.5,244.4 568.8,244.1 552.5,245.9 C480.1,254.1 417.3,281.1 363.5,327.2 C351.9,337.1 329.4,360.2 320.7,371.1 C286.3,414.2 263.4,461.9 252.1,514.1 C237.3,581.6 243.8,653.5 270.4,717.6 C280.3,741.4 298.2,772.3 314.3,793.5 C372.8,870.4 462.3,919.3 559.5,927.4 C569.2,928.2 605.5,928 616,927.1 Z"
                      id="Shape"
                    ></path>
                    <path
                      d="M562.7,855.1 C527.7,851.7 497.2,843 466,827.5 C438.8,814 416.9,798.2 395.5,776.7 C354.8,735.8 329.8,686.9 319.9,629 C317.2,613.1 316.2,576.9 317.9,559.5 C321.3,526.3 330,496.6 345.1,466.1 C358.2,439.8 372.3,419.9 392.9,398.7 C435.8,354.7 487.6,328.5 551,318.9 C564.6,316.8 610.6,317.2 625.5,319.5 C653.2,323.7 680.3,332.3 705.7,344.8 C732.1,357.7 755.4,374.5 776.5,395.6 C819.8,438.9 846.3,493.1 854.2,554.6 C856.3,571 855.7,607.8 853.2,624.6 C843.8,685.9 817.6,737 773.9,779.6 C731.4,821 678.5,846.4 619,854.1 C607.7,855.6 573.7,856.2 562.7,855.1 Z M616.5,823.5 C658.3,818.5 702.5,799.6 736.7,772 C755.7,756.7 778.2,730.9 790.7,710.1 C806.5,683.8 816.6,656.6 822.1,625.6 C824.8,610.5 825.8,576.5 824.1,561 C815.9,489.3 776.7,425.7 716,385.8 C673,357.6 617.7,343.6 567,348 C511.5,352.9 460.8,375.8 420.1,414.5 C405.4,428.5 386.2,453.8 375.7,473.2 C362.7,497.2 353.9,523.8 349.3,553.1 C346.9,569 346.9,604 349.4,619.9 C353.4,645.9 360.2,667.6 371.4,690.6 C397.7,744.4 443.2,786.8 498,808.5 C536.1,823.5 574.7,828.4 616.5,823.5 Z"
                      id="Shape"
                    ></path>
                    <path
                      d="M568.1,767 C512.7,761.7 461.5,729.7 431.8,681.9 C418,659.7 409.1,633.9 405.9,606.6 C404.2,592.5 405.2,565.4 408,551.7 C418.9,496.5 454.6,449.4 504.3,424.5 C533.1,410 558.6,404.4 592,405.4 C620.3,406.3 641.7,411.5 666.5,423.6 C686,433.1 701.3,444.4 717.7,461.4 C730.4,474.7 739.3,487.3 747.9,504.1 C773.7,555 774.4,614.4 749.5,665.7 C716.5,733.9 644.1,774.3 568.1,767 Z"
                      id="Path"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            <div className="hidden sm:ml-6 sm:flex space-x-8">
              <Link
                to="/"
                className="inline-flex items-center px-1 pt-1 text-sm font-medium leading-5 text-gray-900 transition duration-150 ease-in-out border-b-2 border-red-500 focus:outline-none focus:border-red-700"
              >
                Live
              </Link>
              <a
                href="/"
                className="inline-flex items-center px-1 pt-1 text-sm font-medium leading-5 text-gray-500 transition duration-150 ease-in-out border-b-2 border-transparent hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300"
              >
                Calendar
              </a>
              <a
                href="/"
                className="inline-flex items-center px-1 pt-1 text-sm font-medium leading-5 text-gray-500 transition duration-150 ease-in-out border-b-2 border-transparent hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300"
              >
                Orders
              </a>
              <Link
                to="/services"
                className="inline-flex items-center px-1 pt-1 text-sm font-medium leading-5 text-gray-500 transition duration-150 ease-in-out border-b-2 border-transparent hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300"
              >
                Listings
              </Link>
              <a
                href="/"
                className="inline-flex items-center px-1 pt-1 text-sm font-medium leading-5 text-gray-500 transition duration-150 ease-in-out border-b-2 border-transparent hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300"
              >
                Publish
              </a>
              <a
                href="/"
                className="inline-flex items-center px-1 pt-1 text-sm font-medium leading-5 text-gray-500 transition duration-150 ease-in-out border-b-2 border-transparent hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-300"
              >
                Reports
              </a>
              <p>
                {state.value} - {app?.user?.firstName}
              </p>
            </div>
          </div>
          {state.matches('ready') && (
            <>
              <div className="hidden sm:ml-6 sm:flex sm:items-center">
                <button
                  className="p-1 text-gray-400 transition duration-150 ease-in-out border-2 border-transparent rounded-full hover:text-gray-500 focus:outline-none focus:text-gray-500 focus:bg-gray-100"
                  aria-label="Notifications"
                >
                  <svg
                    className="w-6 h-6"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                    />
                  </svg>
                </button>
                <div
                  data-todo-at-click-away="open = false"
                  className="relative ml-3"
                >
                  <div>
                    <button
                      onClick={toggle}
                      className="flex text-sm transition duration-150 ease-in-out border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300"
                      id="user-menu"
                      aria-label="User menu"
                      aria-haspopup="true"
                    >
                      <img
                        className="w-8 h-8 rounded-full"
                        src={app.user?.avatarUrl}
                        alt=""
                      />
                    </button>
                  </div>

                  <div
                    data-todo-x-transition-enter="transition ease-out duration-200"
                    data-todo-x-transition-enter-start="transform opacity-0 scale-95"
                    data-todo-x-transition-enter-end="transform opacity-100 scale-100"
                    data-todo-x-transition-leave="transition ease-in duration-75"
                    data-todo-x-transition-leave-start="transform opacity-100 scale-100"
                    data-todo-x-transition-leave-end="transform opacity-0 scale-95"
                    className={`${
                      open ? 'visible' : 'invisible'
                    } absolute right-0 w-48 mt-2 origin-top-right rounded-md shadow-lg`}
                  >
                    <div className="py-1 bg-white rounded-md shadow-xs">
                      <a
                        href="/"
                        className="block px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                      >
                        Your Profile
                      </a>
                      <a
                        href="/"
                        className="block px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                      >
                        Settings
                      </a>
                      <button
                        onClick={() => send('LOGOUT')}
                        className="block px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                      >
                        Sign out
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center -mr-2 sm:hidden">
                <button
                  onClick={toggle}
                  className="inline-flex items-center justify-center p-2 text-gray-400 transition duration-150 ease-in-out rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500"
                  aria-label={open ? 'Close main menu' : 'Main menu'}
                  aria-expanded={open}
                >
                  <svg
                    className="w-6 h-6"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      className={open ? 'hidden' : 'inline-flex'}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                    <path
                      className={!open ? 'hidden' : 'inline-flex'}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      <div className={open ? 'block sm:hidden' : 'hidden'}>
        <div className="pt-2 pb-3">
          <a
            href="/"
            className="block py-2 pl-3 pr-4 text-base font-medium text-red-700 transition duration-150 ease-in-out border-l-4 border-red-500 bg-red-50 focus:outline-none focus:text-red-800 focus:bg-red-100 focus:border-red-700"
          >
            TODO make the same as other menu
          </a>
          <a
            href="/"
            className="block py-2 pl-3 pr-4 mt-1 text-base font-medium text-gray-600 transition duration-150 ease-in-out border-l-4 border-transparent hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300"
          >
            Team
          </a>
          <a
            href="/"
            className="block py-2 pl-3 pr-4 mt-1 text-base font-medium text-gray-600 transition duration-150 ease-in-out border-l-4 border-transparent hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300"
          >
            Projects
          </a>
          <a
            href="/"
            className="block py-2 pl-3 pr-4 mt-1 text-base font-medium text-gray-600 transition duration-150 ease-in-out border-l-4 border-transparent hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300"
          >
            Calendar
          </a>
        </div>
        {state.matches('ready') && (
          <>
            <div className="pt-4 pb-3 border-t border-gray-200">
              <div className="flex items-center px-4">
                <div className="flex-shrink-0">
                  <img
                    className="w-10 h-10 rounded-full"
                    src={app.user?.avatarUrl}
                    alt=""
                  />
                </div>
                <div className="ml-3">
                  <div className="text-base font-medium leading-6 text-gray-800">
                    {app.user?.firstName} {app.user?.lastName}
                  </div>
                  <div className="text-sm font-medium leading-5 text-gray-500">
                    {app.user?.email}
                  </div>
                </div>
              </div>
              <div
                className="mt-3"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu"
              >
                <a
                  href="/"
                  className="block px-4 py-2 text-base font-medium text-gray-500 transition duration-150 ease-in-out hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100"
                  role="menuitem"
                >
                  Your Profile
                </a>
                <a
                  href="/"
                  className="block px-4 py-2 mt-1 text-base font-medium text-gray-500 transition duration-150 ease-in-out hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100"
                  role="menuitem"
                >
                  Settings
                </a>
                <button
                  onClick={() => send('LOGOUT')}
                  className="block px-4 py-2 mt-1 text-base font-medium text-gray-500 transition duration-150 ease-in-out hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:text-gray-800 focus:bg-gray-100"
                  role="menuitem"
                >
                  Sign out
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </nav>
  )
}

export default Header
